import { BottomTabBarButtonProps } from "@react-navigation/bottom-tabs";
import { PlatformPressable } from "@react-navigation/elements";
import * as Haptics from "expo-haptics";
import { useTheme } from "@/hooks/useTheme";
import { useState } from "react";
import { Platform } from "react-native";

export function HapticTab(props: BottomTabBarButtonProps) {
  const { colors } = useTheme();
  const [hovered, setHovered] = useState(false);
  const isWeb: boolean = Platform.OS === "web";
  return (
    <PlatformPressable
      {...props}
      onHoverIn={() => {
        setHovered(true);
      }}
      onHoverOut={() => {
        setHovered(false);
      }}
      style={[props.style, hovered && isWeb && { backgroundColor: colors.border }]}
      onPressIn={(ev: any) => {
        if (process.env.EXPO_OS === "ios") {
          // Add a soft haptic feedback when pressing down on the tabs.
          Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        }
        props.onPressIn?.(ev);
      }}
    />
  );
}
